module.exports = __webpack_public_path__ + "img/user-add.4dd8f768.svg";